const fontSizes = {
    sm: {
        heading: "text-2xl md:text-3xl",
        subheading: "text-md md:text-lg",
        content: "text-md leading-tight",
    },
    base: {
        heading: "text-3xl md:text-4xl",
        subheading: "text-lg md:text-xl leading-tight",
        content: "text-[18px] md:text-[20px] leading-[28px]",
    },
    lg: {
        heading: "text-4xl md:text-5xl",
        subheading: "text-xl md:text-2xl",
        content: "text-xl md:text-2xl leading-relaxed",
    },
};

export default fontSizes;
